import withLoader from "../../../../../components/layouts/WithLoader"






const UpdateOperation=({startLoading,stopLoading})=>{





  return (
    <></>
  )



}
export default withLoader(UpdateOperation)